import { z } from 'zod';
/** 构建阶段注入的应用环境变量，统一转换为业务可直接使用的类型。 */
const rawEnvSchema = z.object({
    apiBaseUrl: z.string().trim().min(1).default('/api'),
    apiTimeoutMs: z.coerce.number().int().positive().default(300_000),
    appTitle: z.string().trim().min(1).default('Inyou'),
});
/**
 * 已校验的应用环境配置，禁止业务模块直接读取 process.env。
 *
 * 注意：`process.env.X` 必须在源码中**原样书写**。Webpack 的 DefinePlugin 是按字面量
 * 做静态文本替换，只认点号表达式本身；浏览器里并不存在 `process` 全局对象。
 * 因此不要写成 `typeof process === 'undefined' ? undefined : process.env.X` 这类兜底：
 * 该判断在浏览器里恒为真，会把开关静默解析成 undefined。
 */
export const appEnv = rawEnvSchema.parse({
    apiBaseUrl: process.env.APP_API_BASE_URL,
    apiTimeoutMs: process.env.APP_API_TIMEOUT_MS,
    appTitle: process.env.APP_APP_TITLE,
});
/** 供测试和启动诊断展示的非敏感环境摘要。 */
export const appEnvironmentSummary = {
    apiBaseUrl: appEnv.apiBaseUrl,
    appTitle: appEnv.appTitle,
};
